module.exports = __webpack_public_path__ + "static/media/banner_royalgaming-half.f3aeb75c.png";